/**
 * Returns true if the provided permission is one allowed permission for the logged user.
 *
 * @param permission
 * @returns {*}
 */
export function can (permission) {
    return window.permissions.includes(permission);
}
